import { Component, input, model } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

/**
 * Coquille générique autour de p-dialog, pour éviter de redupliquer la même
 * configuration (modal, largeur, masque non-fermant…) sur chaque page.
 *
 * Usage :
 *   <app-dialog [(visible)]="dialogVisible" header="…" width="480px">
 *     … contenu …
 *     <div dialogFooter>
 *       <button pButton … ></button>
 *     </div>
 *   </app-dialog>
 */
@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './app-dialog.html'
})
export class AppDialog {
  visible = model<boolean>(false);
  header = input<string>('');
  width = input<string>('580px');
  dismissableMask = input<boolean>(false);
  styleClass = input<string>('');
}
